import { formatMoney } from "../../toll/money";
import { fundraising_campaign_smaller_enter_button, goal_coin_small } from "../../imgs";
import { useState } from "react";
import { MyColor } from "../../config/myStyle";
import { GetCampaignRes } from "../../api";
import CampaignDeadline from "../../components/CampaignDeadline";
import { useTranslation } from "react-i18next";
import { getCampaignThemeFallback } from "../../toll/campaignThemeVisual";

type HomeCampaignItemProps = {
  onClick(campaignId: string): void
  campaign: GetCampaignRes
}

const HomeCampaignItem = (props: HomeCampaignItemProps) => {
  const { t } = useTranslation();
  const coverUrl = props.campaign.campaignAssets?.find(item => item.position === 'cover')?.url?.trim();
  const fallbackCover = getCampaignThemeFallback(props.campaign.campaignTheme?.name).cover;
  // 缺图或上传图片加载失败时使用内置主题图；记录失败地址，新封面仍可正常加载。
  const [failedCover, setFailedCover] = useState<string>();
  const cover = coverUrl && coverUrl !== failedCover ? coverUrl : fallbackCover;

  const ratioAmount = (props.campaign.raisedAmount / props.campaign.goalAmount * 100).toFixed(0);

  return (
    <div
      className="min-w-[260px] w-[260px] shrink-0"
      style={{
        boxShadow: props.campaign.status === 'completed' ? 'none' : "0 0 8px rgba(0,0,0,0.5) ",
        borderRadius: 5,
        backgroundColor: 'white',
        borderBottomRightRadius: 40,
        borderWidth: props.campaign.status === 'completed' ? 4 : undefined,
        borderColor: props.campaign.status === 'completed' ? '#E84787' : undefined,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {props.campaign.status === 'completed' && (
        <>
          <div
            className="size-[200px] bg-[#E84787]"
            style={{
              position: 'absolute',
              left: -135,
              top: -135,
              transform: 'rotate(45deg)',
            }}
          />
          <img
            className="size-[65px]"
            src={goal_coin_small}
            style={{
              position: 'absolute',
              top: 2,
              left: 2,
              borderRadius: '50%',
            }}
            alt=""
          />
        </>
      )}

      <img src={cover} alt={props.campaign.title} onError={cover !== fallbackCover ? () => setFailedCover(coverUrl) : undefined} style={{ display: 'block', width: '100%', borderTopLeftRadius: 5, borderTopRightRadius: 5, aspectRatio: '16 / 9', objectFit: "cover" }} />
      <div className="px-[14px] pt-[7px] pb-[1px]" >
        <div
          style={{
            color: MyColor.blue,
            fontWeight: 500,
          }}
          className="text-[22px]  truncate">{props.campaign.title}</div>

        <div className="text-[12px] text-[#555]" style={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical"
        }}>{props.campaign.subTitle}</div>
        <div className="flex mt-[10px]">
          <div className="bg-[#e84787]  h-[2.5px]" style={{ width: `${ratioAmount}%` }} />
          <div className="bg-[rgba(0,0,0,0.2)] flex-1 h-[2.5px]" />
        </div>
        <div className="pb-[6px] pt-[3px]">
          <div className="flex items-center text-[#e84787] text-[15px]"
            style={{
              fontStyle: 'italic',
              fontWeight: 500,
            }}
          >
            {t('home_campaign_item.raised_so_far')}
          </div>
          <div className="text-[19px]  text-[#e84787]" style={{ fontWeight: 700 }}>HK$ {formatMoney(props.campaign.raisedAmount)}</div>
          <div className="flex " style={{ alignItems: 'end', transform: 'translateY(-5px)' }}>
            <div className="flex-col flex-1 items-center justify-between text-[15px] text-[#555] mt-[2px]">
              <div className="bg-[rgba(0,0,0,0.3)]  h-[1.5px] w-full" />
              <div className="flex">
                <div className="text-[12px]  text-[#555] font-[600] opacity-[0.9]">
                  <div>{ratioAmount}% </div>
                  <div>{t('home_campaign_item.funded')}</div>
                </div>
                <div className="text-[12px]  text-[#555] font-[600] opacity-[0.9] ml-[20px]">
                  <CampaignDeadline endDate={props.campaign.expectedEndDate} stacked />
                </div>
              </div>
            </div>
            {/* 使用真正的按钮提供键盘操作和可访问名称。 */}
            <button type="button" aria-label={`${t('home_campaign_item.view_campaign')}: ${props.campaign.title}`} onClick={() => props.onClick(props.campaign.id || '')}>
            <img
              className="size-[50px]"
              src={fundraising_campaign_smaller_enter_button}
              alt=""
            />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeCampaignItem;
